'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _semanticUiReact = require('semantic-ui-react');

var _reactRedux = require('react-redux');

var _templateData = require('redux/modules/templateData');

var templateData = _interopRequireWildcard(_templateData);

var templateActions = _interopRequireWildcard(_templateData);

require('./SocialBox.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialBox = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    sectionMargin: state.templateData.inter_section_margin,
    show_social_editor: state.templateData.show_social_editor
  };
}, {
  showSocialEditor: templateActions.showSocialEditor
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(SocialBox, _Component);

  function SocialBox(props) {
    (0, _classCallCheck3.default)(this, SocialBox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SocialBox.__proto__ || (0, _getPrototypeOf2.default)(SocialBox)).call(this, props));

    _this.handleClick = function () {
      _this.props.showSocialEditor(true);
    };

    var _this$props = _this.props,
        type = _this$props.type,
        placeholder = _this$props.placeholder,
        defaultValue = _this$props.defaultValue;

    _this.state = {
      // data_id: this.props.data_id,
      data_parent: _this.props.data_parent,
      social_data: _this.props.social_data,
      socialX: 0,
      socialY: 0,
      socialEditorVisible: false
    };
    return _this;
  }

  (0, _createClass3.default)(SocialBox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.show_social_editor != nextProps.show_social_editor) {
        this.setState({ social_data: nextProps.social_data });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data_parent = _props.data_parent,
          socialIconClass = _props.socialIconClass,
          socialTextClass = _props.socialTextClass,
          socialWrapperClass = _props.socialWrapperClass,
          socialCombinedClass = _props.socialCombinedClass;
      var _state = this.state,
          socialEditorVisible = _state.socialEditorVisible,
          social_data = _state.social_data;

      var social_array = false;
      if (social_data) {
        social_array = social_data;
      }

      var SocialBlock = social_array && social_array.map(function (social_entry, index) {
        var social_type = social_entry['social'];
        var social_value = social_entry['value'];
        return _react2.default.createElement(
          'div',
          { className: 'social-section-' + index + ' single-social-wrapper ' + social_type + '-wrapper ' + socialCombinedClass },
          _react2.default.createElement('i', { className: 'fa fa-' + social_type + ' ' + social_type + '-icon social-icon ' + socialIconClass }),
          _react2.default.createElement(
            'div',
            { className: social_type + '-value social-value ' + socialTextClass },
            social_value
          )
        );
      });

      return _react2.default.createElement(
        'div',
        { className: 'socialWrapper' },
        _react2.default.createElement(
          'div',
          { className: 'hideSocialIcon' },
          _react2.default.createElement(
            'div',
            { className: 'singleSocialIcon', onClick: this.handleClick },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'edit' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'social-section-wrapper ' + socialWrapperClass },
          SocialBlock
        )
      );
    }
  }]);
  return SocialBox;
}(_react.Component)) || _class);
exports.default = SocialBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialBox/SocialBox.js
// module id = 1747
// module chunks = 0